export default __webpack_public_path__ + "static/media/blackT.6118af78.jpg";